// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__xuKOp","footerLink":"Footer_footerLink__VM8--"};